import {
    Button,
    Card,
    CardContent,
    CardHeader,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    TextField
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';
import { InputPhoneMask } from '../../components/input-numbers';

const OrdererPage = ({ order }) => {
    const [user, setUser] = useState({});
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm();
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await apiService.get(`/users/find/${order.username}`);
                const payload = response.data;
                setUser(payload.data);
            } catch (error) {
                console.error(error);
            }
        }

        order.username && fetchData().catch((error) => {
            console.error('Error fetching user data:', error);
        });
    }, [order]);

    useEffect(() => {
        const defaultValues = {
            order_name: user?.order_name,
            order_hp: user?.order_phone,
            order_email: user?.order_email
        }
        reset(defaultValues);
    }, [reset, user]);

    const onSubmit = async (data, e) => {
        const params = {
            "order_name": data.order_name,
            "order_hp": data.order_hp,
            "order_email": data.order_email,
        };

        try {
            await apiService.put(`/orders/order/${order.username}`, params);
            toast.success('업데이트 되었습니다.');
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <Card>
            <CardHeader title='주문자 정보' titleTypographyProps={{ variant: 'h6' }} />
            <CardContent>
                <form onSubmit={handleSubmit(onSubmit)} id="ordererform">
                    <Grid container spacing={6}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='order_name'
                                    control={control}
                                    defaultValue=''
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='주문자'
                                            id='order_name'
                                            onChange={onChange}
                                            placeholder='주문자을 입력해주세요'
                                            error={Boolean(errors.order_name)}
                                            aria-describedby='validation-async-order_name'
                                        />
                                    )}
                                />
                                {errors.order_name && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-order_name'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="order_hp">연락처(휴대폰)</InputLabel>
                                <Controller
                                    name='order_hp'
                                    control={control}
                                    defaultValue=''
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <InputPhoneMask
                                            mask="000-0000-0000"
                                            value={value}
                                            label='연락처(휴대폰)'
                                            id='order_hp'
                                            onChange={onChange}
                                            placeholder='휴대폰 번호를 입력해주세요'
                                            error={Boolean(errors.order_hp)}
                                            aria-describedby='validation-async-order_hp'
                                        />
                                    )}
                                />
                                {errors.order_hp && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-order_hp'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='order_email'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=''
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            type='email'
                                            value={value}
                                            label='이메일'
                                            id='order_email'
                                            onChange={onChange}
                                            placeholder='이메일를 입력해주세요'
                                            error={Boolean(errors.order_email)}
                                            aria-describedby='validation-async-order_email'
                                        />
                                    )}
                                />
                                {errors.order_email && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-order_email'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sx={{ pt: theme => `${theme.spacing(7)} !important` }}>
                            <Button type="submit" form="ordererform" variant='contained' sx={{ mr: 4 }}>
                                수정
                            </Button>
                        </Grid>

                    </Grid>
                </form>
            </CardContent>
        </Card>
    )
}

export default OrdererPage
